var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('section',[_c('header',[_c('h2',[_vm._v("Account settings for @"+_vm._s(_vm.$store.state.username))])]),_c('ChangeUsernameForm'),_c('ChangePasswordForm')],1),_c('section',[_vm._m(0),_c('LogoutForm'),_c('DeleteAccountForm')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h2',[_vm._v("Account management")])])
}]

export { render, staticRenderFns }